module.exports = __webpack_public_path__ + "static/instagram-18442efcdfaa2f32e7869e24d2da2b31.png";